import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import What from "./What";
import How from "./How";

function Home() {
  return (
    <div>
      <Container style={{ paddingTop: "40px", paddingBottom: "40px" }}>
        <Row className="align-items-center">
          <Col md={7}>
            <h1>JSONHelper — Visualize and Explore JSON</h1>
            <p>
              JSONHelper is a browser-based tool that converts JSON into a clean,
              collapsible visual map. Paste your JSON and instantly explore
              objects, arrays, and deeply nested structures without losing your place.
            </p>

            <p>
              If you work with REST APIs, logs, configuration files, or NoSQL exports,
              you already know that large JSON payloads can be difficult to read.
              JSONHelper makes JSON more human-readable by formatting, color-coding,
              and letting you expand/collapse sections as you navigate.
            </p>

            <Link to="/tool">
              <Button variant="primary">Open the JSON Visualizer</Button>
            </Link>
          </Col>

          <Col md={5}>
            <div style={{ borderRadius: "12px", padding: "16px", background: "#0b1220" }}>
              <h5 style={{ color: "white" }}>Tip</h5>
              <p style={{ color: "#cbd5e1", marginBottom: 0 }}>
                Nothing you paste is stored on our servers — the conversion happens in your browser.
              </p>
            </div>
          </Col>
        </Row>

        <hr style={{ margin: "40px 0" }} />

        {/* Reuse your existing content blocks */}
        <What />
        <hr style={{ margin: "40px 0" }} />
        <How />
      </Container>
    </div>
  );
}

export default Home;